var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { buildDemoSummaryTeamAverageDiff } from '@web/lib/demo/utils';
import { getPercentageDiff, randomInt } from '@workalizer/shared/utils';
import { differenceInDays } from 'date-fns';
var buildCountMetric = function (count, previousCount, includeTeamAverage) {
    if (includeTeamAverage === void 0) { includeTeamAverage = false; }
    return (__assign({ count: count, previous: getPercentageDiff(previousCount, count) }, (includeTeamAverage
        ? { teamAverage: buildDemoSummaryTeamAverageDiff(count) }
        : {})));
};
var buildShareMetric = function (share, previousShare) { return ({
    share: share,
    previous: getPercentageDiff(previousShare, share)
}); };
var buildWhereSegment = function (share, previousShare, oneToOneShare, previousOneToOneShare, groupShare, previousGroupShare) { return ({
    share: share,
    previous: getPercentageDiff(previousShare, share),
    format: {
        oneToOne: buildShareMetric(oneToOneShare, previousOneToOneShare),
        group: buildShareMetric(groupShare, previousGroupShare)
    }
}); };
export var chatSummary = function (input) {
    var includeTeamAverage = input.userId != null;
    var messagesSent = randomInt(4200, 5200);
    var previousMessagesSent = randomInt(3800, 4600);
    var messagesReceived = randomInt(3400, 4200);
    var previousMessagesReceived = randomInt(3100, 3900);
    var reactionsSent = randomInt(580, 760);
    var previousReactionsSent = randomInt(520, 680);
    var reactionsReceived = randomInt(400, 560);
    var previousReactionsReceived = randomInt(360, 500);
    var sentOneToOne = randomInt(1700, 2200);
    var previousSentOneToOne = randomInt(1500, 2000);
    var sentGroup = messagesSent - sentOneToOne;
    var previousSentGroup = previousMessagesSent - previousSentOneToOne;
    var receivedOneToOne = randomInt(1400, 1800);
    var previousReceivedOneToOne = randomInt(1200, 1600);
    var receivedGroup = messagesReceived - receivedOneToOne;
    var previousReceivedGroup = previousMessagesReceived - previousReceivedOneToOne;
    var classifiedSent = sentOneToOne + sentGroup;
    var previousClassifiedSent = previousSentOneToOne + previousSentGroup;
    var oneToOneShare = Math.round((sentOneToOne / classifiedSent) * 100);
    var previousOneToOneShare = Math.round((previousSentOneToOne / previousClassifiedSent) * 100);
    var groupShare = Math.round((sentGroup / classifiedSent) * 100);
    var activeChattersShare = randomInt(58, 74);
    var previousActiveChattersShare = randomInt(52, 70);
    var periodDays = Math.max(differenceInDays(new Date(input.dateTo), new Date(input.dateFrom)) + 1, 1);
    var demoUsersInScope = input.userId != null ? 1 : randomInt(8, 12);
    var avgMsgPerDay = Math.round(messagesSent / periodDays / demoUsersInScope);
    var previousAvgMsgPerDay = Math.round(previousMessagesSent / periodDays / demoUsersInScope);
    var externalShare = randomInt(12, 22);
    var previousExternalShare = randomInt(10, 20);
    var whereChatHappens = {
        inTeam: buildWhereSegment(58, 55, 41, 39, 59, 61),
        crossTeam: buildWhereSegment(27, 29, 38, 40, 62, 60),
        external: buildWhereSegment(15, 16, 52, 50, 48, 50)
    };
    return {
        messagesSentReceived: {
            left: buildCountMetric(messagesSent, previousMessagesSent, includeTeamAverage),
            right: buildCountMetric(messagesReceived, previousMessagesReceived, includeTeamAverage)
        },
        reactionsSentReceived: {
            left: buildCountMetric(reactionsSent, previousReactionsSent, includeTeamAverage),
            right: buildCountMetric(reactionsReceived, previousReactionsReceived, includeTeamAverage)
        },
        whereChatHappens: whereChatHappens,
        oneToOneVsGroup: {
            oneToOneShare: oneToOneShare,
            groupShare: groupShare,
            sharePrevious: getPercentageDiff(previousOneToOneShare, oneToOneShare),
            sent: {
                oneToOne: buildCountMetric(sentOneToOne, previousSentOneToOne, includeTeamAverage),
                group: buildCountMetric(sentGroup, previousSentGroup, includeTeamAverage)
            },
            received: {
                oneToOne: buildCountMetric(receivedOneToOne, previousReceivedOneToOne, includeTeamAverage),
                group: buildCountMetric(receivedGroup, previousReceivedGroup, includeTeamAverage)
            }
        },
        oneToOneRoomsGroups: {
            left: buildCountMetric(randomInt(620, 720), randomInt(560, 660), includeTeamAverage),
            right: buildCountMetric(randomInt(430, 520), randomInt(390, 470), includeTeamAverage)
        },
        activeChattersAvgMsgPerSender: {
            share: input.userId != null
                ? null
                : buildShareMetric(activeChattersShare, previousActiveChattersShare),
            count: buildCountMetric(avgMsgPerDay, previousAvgMsgPerDay, includeTeamAverage)
        },
        externalShareMessages: {
            left: buildShareMetric(externalShare, previousExternalShare),
            right: buildShareMetric(100 - externalShare, 100 - previousExternalShare)
        },
        externalPartners: (function () {
            var count = randomInt(10, 18);
            var previousCount = randomInt(8, 15);
            var diff = count - previousCount;
            return __assign({ count: count, previous: {
                    diff: diff,
                    diffString: diff > 0 ? "+".concat(diff) : ''
                } }, (includeTeamAverage
                ? { teamAverage: buildDemoSummaryTeamAverageDiff(count) }
                : {}));
        })()
    };
};
